import React from "react";
import {Select } from "Components/Form";
import MultiSelect from "../../ui/MultiSelect";
import NamedLocation from "./NamedLocation";
import { ButtonBrand, ButtonWhite } from "../../Components/Button";
import { Link as ScrollLink } from "react-scroll";


let AgencyFilters = ({
                       isSuperAgencyAndHasMultipleAgencies,
                       open,
                       sectionHeader,
                       selectedAgency,
                       getAgencyOptions,
                       getCompanyOptions,
                       agencyOnChange,
                       companyOnChange,
                       isRolePlatformAdmin,
                       isAgency,
                       stateSetter,
                       selectedAgencyAsObj,
                       selectedCompanyAsObj,
  doSearch,
  history,
  searchTerm
                     }) => {


  if(!isAgency && !isRolePlatformAdmin) {
    return null;
  }
  return (
    <React.Fragment>
      {sectionHeader("Search for a customer", "agency")}
      <div className={open.agency ? "" : "hidden"}>
        <div className="md:flex md:flex-wrap p-3">
          <div className="flex w-full row">
              {isSuperAgencyAndHasMultipleAgencies || isRolePlatformAdmin ?  <div className="flex flex-col col col-w-full xl:col-w-1/2">
                <p className="mb-1 block font-normal font-heading text-sm uppercase">
                  Which Agency?
                </p>
                <MultiSelect
                  id="agency-search"
                  options={getAgencyOptions()}
                  name="agency"
                  labelClassName="sr-only"
                  wrapperClassName=""
                  component={Select}
                  onChange={ e => agencyOnChange(e)}
                  placeholder="Select Agency"
                  value={selectedAgencyAsObj}
                />
              </div> : null }

              {selectedAgency || (!isSuperAgencyAndHasMultipleAgencies && !isRolePlatformAdmin) ?
                <div className="flex flex-col col col-w-full xl:col-w-1/2 mt-2 xl:mt-0 ">
                  <p className="mb-1 block font-normal font-heading text-sm uppercase">
                    Search For Company
                  </p>
                  <MultiSelect
                    id="company-search"
                    options={getCompanyOptions()}
                    name="company"
                    labelClassName="sr-only"
                    wrapperClassName=""
                    component={Select}
                    onChange={ e =>companyOnChange(e)}
                    placeholder="Select Company"
                    value={selectedCompanyAsObj}
                  />
                </div> : null
              }
          </div>
        </div>
        <div className="px-3 pt-4 pb-20 h-20 relative">

          <div className="row px-2 py-4 w-full justify-between py-3 mt-10 absolute pin-b bg-light-grey mf">
            <ScrollLink
              to={"location"}
              smooth
              className="pointer"
            >
              <ButtonBrand
                classes="mr-4 text-lg"
                onClick={() =>
                  stateSetter.tab("location", true)
                }
              >
                Next
              </ButtonBrand>
            </ScrollLink>
            <ScrollLink
              smooth
              className="pointer"
              to="results"
            >
              <ButtonWhite>See search results</ButtonWhite>
            </ScrollLink>
          </div>
        </div>
    </div>
    </React.Fragment>
  )
}

export default AgencyFilters